module.exports = __webpack_public_path__ + "img/present.0a875680.png";